let scrollTop = 0;

export const lockScroll = () => {
  const doc = global.document.documentElement || global.document.body;
  const win = global.window;
  const top = win.pageYOffset;

  doc.style.position = 'fixed';
  doc.style.width = '100%';
  doc.style.height = '100%';

  scrollTop = top;
}

export const unLockScroll = () => {
  const doc = global.document.documentElement || global.document.body;
  // const win = global.window;

  doc.style.position = '';
  doc.style.top = '';
  doc.style.width = '';
  document.documentElement.scrollTop = scrollTop;
  document.body.scrollTop = scrollTop;
  // win.pageYOffset = scrollTop;  // 和 headerBar 都计算相互影响

  scrollTop = 0;
}